export default "__VITE_ASSET__d3uP4sPA__"